import { fetchAgencyData } from '@/lib/backend-api'
import { getConfiguration } from '@/lib/utilsUsableOnEdgeRuntime'
import { initializeServerHelper } from '@/lib/serverHelpers'
import { ExtendedDomainConfiguration } from '../../../../../../../../domain-config/domain-config'
import { AppPropsParams } from '@/lib/types'

export interface AppProps {
  params: AppPropsParams
}

export interface AppPropsWithWhiteLabel extends AppProps {
  params: AppPropsParams
  whitelabel: boolean
}

export async function loadBasicPageData(props: AppPropsWithWhiteLabel): Promise<void> {
  const agencyData = await fetchAgencyData(props.params.domain, +props.params.agency)
  const { config } = await loadConfigAndTranslations(props)

  initializeServerHelper(
    config,
    props.params.domain,
    props.params.testvariants,
    agencyData,
    !!props.whitelabel,
    props.params.currency,
  )
}

export async function loadConfigAndTranslations(
  props: AppProps,
): Promise<{ config: ExtendedDomainConfiguration }> {
  const config = await getConfiguration(props.params.domain)

  return { config }
}
